/* eslint-disable max-len */
/**
 * Greek translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {},
  LABEL: {
    NO_ROWS_MENTIONS: 'Δεν υπάρχουν αναφορές'
  },
  SENTENCE: {
    INSTAGRAM_LINK:
      'Αναφέρατε τον Prozis στο instagram την ημέρα {publishedAt}',
    NO_ROWS_MENTIONS: 'Δεν έχετε αναφέρει ακόμα το prozis στο Instagram σας'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
